import React, { useState, useEffect, useContext } from 'react'
import axios from 'axios'
import { Link } from "react-router-dom";
//import { useToasts } from 'react-toast-notifications'
import { AuthContext } from '../../Auth/Auth'
//import { useQuery, useMutation, useQueryClient } from 'react-query'
//import { Form, Col, Row, Modal } from 'react-bootstrap'
import { globalConfig } from '../../../config/config'
import { Loading } from '../../Loading/Loading'
import {
  InputAdornment, Checkbox, 
  IconButton,
  TextField,
  Container,
  MenuItem,
  Tabs,
  Tab,
  Typography,
  Drawer, 
  InputLabel,
  Button
} from '@mui/material';

export default function ProblemTicketSearch() {

	return (
	<>

        <div class="container-fluid">
          <div className="d-flex flex-row justify-content-between mb-3 mt-3">
            <h4>Ticket Search</h4>
			  <div>
            <Link to="/eqius/create-ticket" className="btn-success btn">
              Create Ticket
            </Link>
            &nbsp;
            <Link to="/" className="btn-primary btn">
              Home
            </Link>
            &nbsp;
            <Link to="/eqius" className="btn-danger btn">
              Back
            </Link>
            &nbsp;
            <Link to="/eqius" className="btn-info btn">
              My Tickets
            </Link>
            </div>
          </div>

<center>

		<TextField  
			sx={{ m: 2 }}
				fullWidth
				label="Ticket Number"
				id="problemTicketNumber">
		</TextField>

		<TextField 
			sx={{ m: 2 }}
				fullWidth
				label="Ticket Title"
				styleClass="form-control input-medium"  id="problemTicketTitle">
		</TextField>
		<TextField 
			sx={{ m: 2 }}
				id="reporterId"
				value="Reporter"
				fullWidth
			>
		    <option label="#{ombUsersSelectControl.getUserListByFirstLastName()}" />
	    </TextField>
		
		{/*
		<label styleClass="ContentTitle" >Exclude from Search Results</label>
		<Checkbox 
			label="Exclude from Search Results"
			id="excludeReporter" value="#{ombProblemTicketForm.excludeReporter}" />
		*/}
		<TextField
			sx={{ m: 2 }}
			fullWidth 
				label="Approver"
				id="approverId">
		    <option value="#{ombUsersSelectControl.getUserListByFirstLastName()}" />
	    </TextField>
		
		{/*
		<label styleClass="ContentTitle" >Exclude from Search Results</label>
		<Checkbox 
			label="Exclude from Search Results"
			id="excludeApprover" value="#{ombProblemTicketForm.excludeApprover}" />
		*/}
		
		<TextField 
			sx={{ m: 2 }}
		fullWidth
				label="Owner"
				id="ownerId">
		    <option value="#{ombUsersSelectControl.getUserListByFirstLastName()}" />
	    </TextField>
		
		{/*
		<label styleClass="ContentTitle" >Exclude from Search Results</label>
		<Checkbox 
			fullWidth
			label="Exclude from Search Results" 
			id="excludeOwner" value="#{ombProblemTicketForm.excludeOwner}" />
		*/}
		
		<TextField 
			sx={{ m: 2 }}
			fullWidth
			label="Assignee" 
			id="assigneeId">
		    <option value="#{ombUsersSelectControl.getUserListByFirstLastName()}" />
		    </TextField>
		
		{/*
		<label styleClass="ContentTitle" >Exclude from Search Results</label>
		<Checkbox 
			label="Exclude from Search Results" 
			id="excludeAssignee" value="#{ombProblemTicketForm.excludeAssignee}" />
		<InputLabel styleClass="ContentTitle" ></InputLabel>
		*/}
		
		<TextField 
			sx={{ m: 2 }}
			fullWidth
			label="Work Queue"
			id="workQueueId">
		    <option value="#{ombSystemLookupCodesControl.getSystemCodeValuesSelectBox('WORK_QUEUE')}" />
	    </TextField>
		{/*
		<label styleClass="ContentTitle" >Exclude from Search Results</label>
		<Checkbox id="excludeWorkQueue" value="#{ombProblemTicketForm.excludeWorkQueue}" />
		*/}


		<TextField
			sx={{ m: 2 }}
			fullWidth
			select
			label="Type" 
			id="typeCode">
		    <option value="#{ombSystemLookupCodesControl.getSystemCodeValuesSelectBox('ISSUE_TYPE')}" />
	    </TextField>		
		{/*
		<label styleClass="ContentTitle" >Exclude from Search Results</label>
		<Checkbox styleClass="ContentTitle" value="Exclude from Search Results" />		
		<TextField
			select
			fullWidth
			id="excludeTypeCode" value="#{ombProblemTicketForm.excludeTypeCode}" />
		*/}
		
		
		<TextField 
			sx={{ m: 2 }}
			fullWidth
			select
			label="Current Status Code"
			id="currentStatusCode">
		    <option value="#{ombSystemLookupCodesControl.getSystemCodeValuesSelectBox('ISSUE_STATUS')}" />
		    </TextField>
		{/*
		<label styleClass="ContentTitle" >Exclude from Search Results</label>
		<Checkbox styleClass="ContentTitle" value="Exclude from Search Results" />
		<TextField id="excludeCurrentStatusCode" value="#{ombProblemTicketForm.excludeCurrentStatusCode}" />
 		*/} 
  		
  		<TextField
  			sx={{ m: 2 }}
  		  	select
  		   	fullWidth 
  		   	label="Priority"
  	    	id="priorityCode"
  	    >
			<option value="#{ombSystemLookupCodesControl.getSystemCodeValuesSelectBox('TASK_PRIORITY')}"/>
		</TextField>
		{/*
		<label styleClass="ContentTitle" >Exclude from Search Results</label>
		<Checkbox styleClass="ContentTitle" value="Exclude from Search Results" />
		*/}
 		
 		{/*
 		
 		<TextField 
 			id="excludePriorityCode"  /> 
		*/}	
		
		<TextField 
			sx={{ m: 2 }}
			select
			fullWidth
			label="Current Status Performer"
			id="currentStatusUser">
		    <option value="#{ombUsersSelectControl.getUserListByFirstLastName()}" />
		</TextField>		
		{/*
		<label styleClass="ContentTitle" >Exclude from Search Results</label>
		<Checkbox id="excludeCurrentStatusUser" value="#{ombProblemTicketForm.excludeCurrentStatusUser}" />
		*/}

		<TextField 
			sx={{ m: 2 }}
			select
			fullWidth
			label="Current Disposition"
			id="currentDisposition">
		    <option value="#{ombSystemLookupCodesControl.getSystemCodeValuesSelectBox('ISSUE_DISPOSITION')}" />
		</TextField>		
		{/*
		<label styleClass="ContentTitle">Exclude from Search Results</label>
		<Checkbox id="excludeCurrentDisposition" value="#{ombProblemTicketForm.excludeCurrentDisposition}" />
		*/}

		<TextField 
			sx={{ m: 2 }}
			fullWidth
			select
			label="Current Disposition Performer"
			id="currentDispositionUser">
		    <option value="#{ombUsersSelectControl.getUserListByFirstLastName()}" />
	    </TextField>
		
		{/*
		<label styleClass="ContentTitle" >Exclude from Search Results</label>
		<Checkbox id="excludeCurrentDispositionUser" value="#{ombProblemTicketForm.excludeCurrentDispositionUser}" />
		*/}
		
		<TextField 
			sx={{ m: 2 }}
			select
			fullWidth
			label="Reporter Type Code"
			id="reporterTypeCode">
		    <option value="#{ombSystemLookupCodesControl.getSystemCodeValuesSelectBox('REPORTER_TYPE')}" />
		    </TextField>
		
		{/*
		<label styleClass="ContentTitle" >Exclude from Search Results</label>
		<Checkbox id="excludeReporterTypeCode" value="#{ombProblemTicketForm.excludeReporterTypeCode}" />
		*/}
		
		<TextField 
			sx={{ m: 2 }}
			select 
			fullWidth
			label="Environment"
			id="environmentId">
		    <option value="#{ombSystemLookupCodesControl.getSystemCodeValuesSelectBox('ENVIRONMENTS')}" />
		</TextField>
		{/*
		<label styleClass="ContentTitle">Exclude from Search Results</label>
		<Checkbox id="excludeEnvironment" value="#{ombProblemTicketForm.excludeEnvironment}" />
		*/}
				
		<TextField 
			sx={{ m: 2 }}
			fullWidth
			select
			label="Operating System"
			id="operatingSystemId">
		    <option value="#{ombSystemLookupCodesControl.getSystemCodeValuesSelectBox('OPERATING_SYSTEMS')}" />
	    </TextField>
		
		{/*
		<label styleClass="ContentTitle">Exclude from Search Results</label>
		<Checkbox id="excludeOperatingSystem" value="#{ombProblemTicketForm.excludeOperatingSystem}" />
		*/}
	<hr />

		<center>
 				<Button color="success" variant="contained" value="Search" id="searchActor" onclick="selectTab('tab_results')"
					actionListener="#{ombProblemTicketForm.search}">Search</Button>&nbsp;
				<Button color="info" variant="contained" value="Clear" immediate="true" type="reset">Clear</Button>
		</center>


</center>
	</div>
</>
);
}
// export default ProblemTicketSearch;
